import Point from "../structures/Point";
import {getButtonBottomCenterSvg, getPortTopCenterSvg} from "../utils/SvgUtils";
import Edge from "../structures/Edge";
import config from "../config/GraphViewConfig";
import {graph} from "./GraphService";

function computeEdges(nodes, edgesData) {
    if (!edgesData || !nodes || !nodes.length) return [];

    const edges = []

    const movableContainer = document.querySelector("#graph-translatable-g");
    if (movableContainer) {
        edgesData.forEach((edgeData, index) => {
            const destinationNode = nodes.find(n => n.id === edgeData.questionId)

            const startNodeId = graph.buttonNodeMapping[edgeData.buttonId];
            const startNode = nodes.find(n => n.id === startNodeId);

            if (!destinationNode || !startNode) return



            const buttonIndex = startNode.data.buttons.findIndex(b => b.id === edgeData.buttonId)
            const buttonsContainerWidth = startNode.data.buttons.length * (config.design.node.button.width + config.design.node.buttonsGap) + config.design.node.button.width;

            const buttonBottomPoint = new Point(
                startNode.x +
                (buttonIndex * (config.design.node.button.width + config.design.node.buttonsGap)) +
                config.design.node.button.width / 2 +
                (buttonsContainerWidth > startNode.width ? 0 : (startNode.width - buttonsContainerWidth) / 2)
                ,
                startNode.y + startNode.height
            )

            const secondPoint = new Point(buttonBottomPoint.x, buttonBottomPoint.y + config.design.node.defaultEdgeStartVerticalOffset)

            const edge = new Edge([], edgeData.buttonId, edgeData.questionId)
            const edge2 = new Edge([], edgeData.buttonId, edgeData.questionId)

            edge.addPoint(buttonBottomPoint)
            edge.addPoint(secondPoint)
            edge2.addPoint(buttonBottomPoint)
            edge2.addPoint(secondPoint)


            const portTopPoint = new Point(destinationNode.x + destinationNode.width / 2, destinationNode.y)
            const portTopPointPrevPoint = new Point(portTopPoint.x, portTopPoint.y - config.design.node.defaultEdgeStartVerticalOffset)

            let edgeFailed = false;
            let edge2Failed = false;

            try {
                //if (edge.buttonId === 365) debugger
                buildEdgePoints(edge, portTopPointPrevPoint, nodes)
            } catch (e) {
                console.error(`Exception while building edge point for edge:`, edge)
                console.log(e)
                edgeFailed = true;
                edge.addPoint(portTopPointPrevPoint)
            }
            edge.addPoint(portTopPoint)

            try {
                //if (edge.buttonId === 365) debugger
                const alternativeSucceeded = initialAlternativePassBy(edge2,portTopPointPrevPoint,nodes)
                if(!alternativeSucceeded) {
                    edge2Failed = true
                }else{
                    buildEdgePoints(edge2, portTopPointPrevPoint, nodes,'left')
                }
            } catch (e) {
                console.error(`Exception while building edge point for edge:`, edge)
                console.log(e)
                edge2Failed = true;
                edge2.addPoint(portTopPointPrevPoint)
            }
            edge2.addPoint(portTopPoint)

            //if (edge.buttonId === 365) debugger

            if(!edgeFailed && !edge2Failed) {
                edges.push(edge.points.length < edge2.points.length ? edge : edge2)
            }else if(edgeFailed) {
                if(!edgeFailed) edges.push(edge2)
            }else{
                edges.push(edge)
            }

        })
    }


    return edges;
}

function buildEdgePoints(edge, destinationPoint, nodes, lastDirection = 'bottom') {

    let nextDirection;

    if (lastDirection === 'bottom' || lastDirection === 'top') {
        if (edge.getLastPoint().x === destinationPoint.x) {
            const canDirectConnect = getDirectionObstacleCandidates(edge.getLastPoint(), destinationPoint, nodes, destinationPoint.y > edge.getLastPoint().y ? 'bottom' : 'top').length === 0;
            if (canDirectConnect) {
                return
            }
        }
        if (destinationPoint.x > edge.getLastPoint().x) {
            nextDirection = 'right'
        } else {
            nextDirection = 'left'
        }
    } else {
        if (destinationPoint.y > edge.getLastPoint().y) {
            nextDirection = 'bottom'
        } else {
            nextDirection = 'top'
        }
    }

    if (((nextDirection === 'bottom' || nextDirection === 'top') && edge.getLastPoint().x === destinationPoint.x) ||
        ((nextDirection === 'left' || nextDirection === 'right') && edge.getLastPoint().y === destinationPoint.y)
    ) {
        if (!pointsHaveObstacle(edge.getLastPoint(), destinationPoint, nodes)) {
            edge.addPoint(destinationPoint)
            return
        }
    }

    const nextPoint = moveUntilObstacle(edge, destinationPoint, nodes, nextDirection)
    edge.addPoint(nextPoint)

    buildEdgePoints(edge, destinationPoint, nodes, nextDirection)

}

function pointsHaveObstacle(p1, p2, nodes) {

    const minX = Math.min(p1.x, p2.x);
    const maxX = Math.max(p1.x, p2.x);
    const minY = Math.min(p1.y, p2.y);
    const maxY = Math.max(p1.y, p2.y);

    for (const node of nodes) {
        const nodeLeft = node.x;
        const nodeRight = node.x + node.width;
        const nodeTop = node.y;
        const nodeBottom = node.y + node.height;

        const overlaps =
            nodeRight > minX &&
            nodeLeft < maxX &&
            nodeBottom > minY &&
            nodeTop < maxY;

        if (overlaps) return true;
    }

    return false;
}

function moveUntilObstacle(edge, destinationPoint, nodes, direction) {
    const lastPoint = edge.getLastPoint();

    if (direction === 'left') {
        const leftObstacleCandidates = getDirectionObstacleCandidates(lastPoint, destinationPoint, nodes, 'left');

        if (leftObstacleCandidates.length > 0) {
            const firstObstacle = leftObstacleCandidates.reduce((acc, n) => (n.x > acc.x ? n : acc), leftObstacleCandidates[0]);
            return new Point(firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes, lastPoint.y);
        }

        const possibleNewPoint = new Point(destinationPoint.x, lastPoint.y);

        const verticalDirection = possibleNewPoint.y > destinationPoint.y ? 'top' : 'bottom'

        const verticalCandidates = getDirectionObstacleCandidates(possibleNewPoint, destinationPoint, nodes, verticalDirection);

        if (verticalCandidates.length > 0) {
            const firstObstacle = verticalDirection === 'top' ?
                verticalCandidates.reduce((acc, n) => (n.y > acc.y ? n : acc), verticalCandidates[0])
                :
                verticalCandidates.reduce((acc, n) => (n.y < acc.y ? n : acc), verticalCandidates[0])

            //read description in 'right' case
            if (
                (verticalDirection === 'top' && (firstObstacle.y + firstObstacle.height + config.design.edgeOffsetFromNodes >= possibleNewPoint.y))
                ||
                (verticalDirection === 'bottom' && (firstObstacle.y - config.design.edgeOffsetFromNodes <= possibleNewPoint.y))
            ) {
                return new Point(
                    edge.getLastPoint().x - firstObstacle.x >
                    (firstObstacle.x + firstObstacle.width - edge.getLastPoint().x) ?
                        firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes :
                        firstObstacle.x - config.design.edgeOffsetFromNodes
                    ,
                    lastPoint.y
                )
            }

        }
        return possibleNewPoint;

    }

    if (direction === 'right') {
        const candidates = getDirectionObstacleCandidates(lastPoint, destinationPoint, nodes, 'right');

        if (candidates.length > 0) {
            const firstObstacle = candidates.reduce((acc, n) => (n.x < acc.x ? n : acc), candidates[0]);
            return new Point(firstObstacle.x - config.design.edgeOffsetFromNodes, lastPoint.y);
        }

        const possibleNewPoint = new Point(destinationPoint.x, lastPoint.y);

        const verticalDirection = possibleNewPoint.y > destinationPoint.y ? 'top' : 'bottom'

        const verticalCandidates = getDirectionObstacleCandidates(possibleNewPoint, destinationPoint, nodes, verticalDirection);

        if (verticalCandidates.length > 0) {
            const firstObstacle = verticalDirection === 'top' ?
                verticalCandidates.reduce((acc, n) => (n.y > acc.y ? n : acc), verticalCandidates[0])
                :
                verticalCandidates.reduce((acc, n) => (n.y < acc.y ? n : acc), verticalCandidates[0])

            //if for possible new point vertical obstacles exists, and they will block next vertical move of path
            // then this logic works and passes by that obstacle
            if (
                (verticalDirection === 'top' && (firstObstacle.y + firstObstacle.height + config.design.edgeOffsetFromNodes >= possibleNewPoint.y))
                ||
                (verticalDirection === 'bottom' && (firstObstacle.y - config.design.edgeOffsetFromNodes <= possibleNewPoint.y))
            ) {
                return new Point(
                    edge.getLastPoint().x - firstObstacle.x >
                    (firstObstacle.x + firstObstacle.width - edge.getLastPoint().x) ?
                        firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes :
                        firstObstacle.x - config.design.edgeOffsetFromNodes
                    ,
                    lastPoint.y
                )
            }


        }
        return possibleNewPoint;
    }

    if (direction === 'top') {
        const candidates = getDirectionObstacleCandidates(lastPoint, destinationPoint, nodes, 'top');

        if (candidates.length > 0) {
            const firstObstacle = candidates.reduce((acc, n) => (n.y > acc.y ? n : acc), candidates[0]);
            const possibleNewPoint = new Point(lastPoint.x, firstObstacle.y + firstObstacle.height + config.design.edgeOffsetFromNodes);

            if (possibleNewPoint.y === lastPoint.y) {
                //means can not move top should bypass obstacle horizontally
                //after this frame it comes again into same place, but now it can move top without obstacle

                edge.removePoint()

                return new Point(
                    edge.getLastPoint().x - firstObstacle.x >
                    (firstObstacle.x + firstObstacle.width - edge.getLastPoint().x) ?
                        firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes :
                        firstObstacle.x - config.design.edgeOffsetFromNodes
                    ,
                    lastPoint.y
                )
            }
            return possibleNewPoint;
        }
        return new Point(lastPoint.x, destinationPoint.y);
    }

    if (direction === 'bottom') {
        const candidates = getDirectionObstacleCandidates(lastPoint, destinationPoint, nodes, 'bottom');

        if (candidates.length > 0) {
            const firstObstacle = candidates.reduce((acc, n) => (n.y < acc.y ? n : acc), candidates[0]);
            const possibleNewPoint = new Point(
                lastPoint.x,
                firstObstacle.y - config.design.edgeOffsetFromNodes
            );

            if (possibleNewPoint.y === lastPoint.y) {
                // means can not move down — should bypass obstacle horizontally
                edge.removePoint();

                return new Point(
                    edge.getLastPoint().x - firstObstacle.x >
                    (firstObstacle.x + firstObstacle.width - edge.getLastPoint().x)
                        ? firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes
                        : firstObstacle.x - config.design.edgeOffsetFromNodes,
                    lastPoint.y
                );
            }

            return possibleNewPoint;
        }

        return new Point(lastPoint.x, destinationPoint.y);
    }
}

function getDirectionObstacleCandidates(sourcePoint, destinationPoint, nodes, direction) {
    const offset = config.design.edgeOffsetFromNodes;

    if (direction === 'left') {
        return nodes.filter(node =>
            node.x + node.width + offset > destinationPoint.x &&
            node.x - offset < sourcePoint.x &&
            node.y + node.height + offset > sourcePoint.y &&
            node.y - offset < sourcePoint.y
        );
    }

    if (direction === 'right') {
        return nodes.filter(node =>
            node.x - offset < destinationPoint.x &&
            node.x + node.width + offset > sourcePoint.x &&
            node.y + node.height + offset > sourcePoint.y &&
            node.y - offset < sourcePoint.y
        );
    }

    if (direction === 'top') {
        return nodes.filter(node =>
            node.y + node.height + offset > destinationPoint.y &&
            node.y - offset < sourcePoint.y &&
            node.x + node.width + offset > sourcePoint.x &&
            node.x - offset < sourcePoint.x
        );
    }

    if (direction === 'bottom') {
        return nodes.filter(node =>
            node.y - offset < destinationPoint.y &&
            node.y + node.height + offset > sourcePoint.y &&
            node.x + node.width + offset > sourcePoint.x &&
            node.x - offset < sourcePoint.x
        );
    }
}

function initialAlternativePassBy(edge,destinationPoint,nodes){
    let direction ;
    const lastPoint = edge.getLastPoint();
    if (destinationPoint.x > lastPoint.x) {
        direction = 'left'
    } else {
        direction = 'right'
    }

    let verticalDirection = destinationPoint.y < edge.getLastPoint().y ? 'top' : 'bottom';

    const candidates = getDirectionObstacleCandidates(lastPoint, destinationPoint, nodes, verticalDirection);

    let firstObstacle;
    if(verticalDirection === 'bottom') {
        firstObstacle = candidates.reduce((acc, n) => (n.y < acc.y ? n : acc), candidates[0]);
    }else{
        firstObstacle = candidates.reduce((acc, n) => (n.y > acc.y ? n : acc), candidates[0]);
    }
    if(!firstObstacle) return false;

    edge.addPoint(
        new Point(
            direction === 'right' ?
                firstObstacle.x + firstObstacle.width + config.design.edgeOffsetFromNodes
                :
                firstObstacle.x - config.design.edgeOffsetFromNodes
            ,
            lastPoint.y
        )
    );
    return true;
}

export {computeEdges}


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/EdgeService.js